import type { WallPosts } from './normalizeWallPosts';

// Will remove the comment and update indexes for other thread comments
// Context: when deleting a thread the server will send us back one message for each comment removal. This will always be the first comment until there are no comments left.
// When there are no more comments in the thread the server will send one last message to remove the thread itself
const handleRemovedComment = (posts: WallPosts[], commentIndex: number, threadIndex: number) =>
  posts
    .filter((post) => {
      const [postThreadIndex, postCommentIndex] = post.path;
      const isDifferentThread = postThreadIndex !== threadIndex;
      const isDifferentComment = postCommentIndex !== commentIndex;

      return isDifferentThread || isDifferentComment;
    })
    .map((post) => {
      const [postThreadIndex, postCommentIndex] = post.path;
      const isSameThread = postThreadIndex === threadIndex;

      if (isSameThread && postCommentIndex > commentIndex) {
        return { ...post, path: [postThreadIndex, postCommentIndex - 1] };
      }

      return post;
    });

const handleRemovedThread = (posts: WallPosts[], threadIndex: number) =>
  posts
    .filter((post) => {
      const [postThreadIndex] = post.path;
      return postThreadIndex !== threadIndex;
    })
    .map((post) => {
      const [postThreadIndex, postCommentIndex] = post.path;
      const isBiggerIndex = postThreadIndex > threadIndex;

      if (isBiggerIndex) {
        return { ...post, path: [postThreadIndex - 1, postCommentIndex] };
      }

      return post;
    });

const handleRemovedThreadOrComment = (posts: WallPosts[], newState: WallPosts) => {
  const [threadIndex, commentIndex] = newState.path;
  if (commentIndex === 0) return handleRemovedThread(posts, threadIndex);

  return handleRemovedComment(posts, commentIndex, threadIndex);
};

const handleWallPostStream = (currentPosts: WallPosts[], newState: WallPosts[]): WallPosts[] => {
  const stateExists = currentPosts && currentPosts.length > 0;
  if (stateExists && newState[0].id !== 0) {
    return [...currentPosts, ...newState];
  } else if (stateExists && (newState[0].id === 0 || newState[0].obsolete)) {
    return handleRemovedThreadOrComment(currentPosts, newState[0]);
  }

  return newState;
};

export default handleWallPostStream;
